/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  AgentFeedbackSource,
  AgentGoal,
  EntityId,
  List,
  SiteInsightsEvent,
  SiteInsightsQueryEventsAggregation,
  SiteInsightsQueryEventsAggregationResult,
  SiteInsightsVisitorSegment,
  URL,
} from "./data-contracts";

/**
 * @description Submit feedback from an AI agent about the content of the site, such as outdated, incorrect or missing content encountered while helping a user. Deprecated in favour of `submitAgentFeedbackToSite`, which collects feedback about every surface a site exposes to agents. Send the same payload there as a `site-content` subject.
 * @tags site-insights
 * @name SubmitSiteAgentFeedback
 * @summary Submit agent feedback for a site. (Deprecated) use submitAgentFeedbackToSite instead.
 * @request POST:/orgs/{organizationId}/sites/{siteId}/agent-feedback
 * @deprecated
 * @secure
 */

// @ts-ignore
export const submitSiteAgentFeedback: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * The feedback about the content of the site.
     * @minLength 1
     * @maxLength 2048
     */
    feedback: string;
    /** The end goal the agent is trying to accomplish on behalf of the user, giving the context the agent was working towards when it encountered the issue. */
    goal?: AgentGoal;
    /** URL of the content the feedback is about. */
    url: URL;
    /** ID of the space the feedback is about. */
    spaceId: string;
    /** ID of the page the feedback is about. */
    pageId: string;
    /** Surface the feedback was submitted from. When omitted, the feedback is recorded with an unknown source. */
    source?: AgentFeedbackSource;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/agent-feedback",
  method: "post",
  streaming: false,
  tags: ["site-insights"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: { errorRate: 0 },
};

/**
 * No description
 * @tags site-insights
 * @name TrackEventsInSiteById
 * @summary Track site events
 * @request POST:/orgs/{organizationId}/sites/{siteId}/insights/events
 * @secure
 */

// @ts-ignore
export const trackEventsInSiteById: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    events: SiteInsightsEvent[];
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/insights/events",
  method: "post",
  streaming: false,
  tags: ["site-insights"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Runs an aggregation query over a published site's Insights events, grouped and filtered over a time range. Use it to answer analytics questions about how visitors engage with a site's documentation: page views, visitors, searches, referrers, and broken URLs (404s). A 404 is a `page_view` or `search_open_result` event whose `page` is `null`, in the `site` display context; filter `eventPageNotFoundType` not in `conditional` to leave out 404s that adaptive content explains. Group by `datetime` for a trend over time and by `urlPath` for the top broken URLs.
 * @tags site-insights
 * @name AggregateSiteEvents
 * @summary Query a site's analytics events
 * @request POST:/orgs/{organizationId}/sites/{siteId}/insights/events/aggregate
 * @secure
 */

// @ts-ignore
export const aggregateSiteEvents: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: SiteInsightsQueryEventsAggregation;
  RequestHeaders: {};
  ResponseBody: SiteInsightsQueryEventsAggregationResult;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/insights/events/aggregate",
  method: "post",
  streaming: false,
  tags: ["site-insights"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-insights
 * @name ListSiteVisitorSegments
 * @summary List a site visitor segments
 * @request GET:/orgs/{organizationId}/sites/{siteId}/insights/visitor-segments
 * @secure
 */

// @ts-ignore
export const listSiteVisitorSegments: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteInsightsVisitorSegment[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/insights/visitor-segments",
  method: "get",
  streaming: false,
  tags: ["site-insights"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
